import type { ICustomControlData } from './TpoV1DiagnosticReportAddEditCustomControlFields';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export function TpoV1DiagnosticReportReadCustomControlFields(props: { customControlData: ICustomControlData }) {
    if (!props.customControlData) {
        return null;
    }

    return (
        <>
            {props.customControlData.restrictief && (
                <HorizontalFormGroupRead>
                    <FormLabel>Restrictief</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.restrictief}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {props.customControlData.obstructief && (
                <HorizontalFormGroupRead>
                    <FormLabel>Obstructie</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.obstructief}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {props.customControlData.ernst_obstructie && (
                <HorizontalFormGroupRead>
                    <FormLabel>Ernst obstructie</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.ernst_obstructie}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {props.customControlData.reversible && (
                <HorizontalFormGroupRead>
                    <FormLabel>Reversible</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.customControlData.reversible}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
